module.exports = __webpack_public_path__ + "img/close.f3addf9d.svg";